import { render } from "./StaticWebUrlLayout.vue?vue&type=template&id=33ca5446&scoped=true&ts=true"
import script from "./StaticWebUrlLayout.vue?vue&type=script&lang=ts"
export * from "./StaticWebUrlLayout.vue?vue&type=script&lang=ts"

import "./StaticWebUrlLayout.vue?vue&type=style&index=0&id=33ca5446&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ca5446"]])

export default __exports__